<!--
    Summary:
        hkml.exhibition.web - contact-us-left
    ChangeLog:
        wangn on 2020/11/29 added
-->
<template>
  <div class="v-contact-us-left" title="contact-us-left">
    <div class="header">
      <h2>{{$t('ContactUsText.p2_title')}}</h2>
    </div>
    <div class="form-wrapper">
      <div class="form-item form-content">
        <el-input class="input-content" rows="13" :placeholder="$t('ContactUsText.p2_1')" type="textarea" v-model="contactForm.leavingMessage"></el-input>
      </div>
      <div class="form-item form-name-phone">
        <el-input class="input-name" :placeholder="$t('ContactUsText.p2_2')" v-model="contactForm.name"></el-input>
        <el-input class="input-phone" :placeholder="$t('ContactUsText.p2_3')" v-model="contactForm.phone"></el-input>
      </div>
      <div class="form-item form-email">
        <el-input :placeholder="$t('ContactUsText.p2_4')" v-model="contactForm.email"></el-input>
      </div>
      <div class="form-item form-btn">
        <el-button class="btn" type="primary" @click="send">{{$t('ContactUsText.p2_action')}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {ConsultionInfo} from '../../service/searchreport'

  export default {
    name: "contact-us-left",
    data() {
      return {
        contactForm: {
          name: '',
          phone: '',
          email: '',
          leavingMessage: ''
        },

      }
    },
    methods: {
      async send() {
        let form = this.contactForm;
        if (!form.leavingMessage)
          return alert(`请输入${this.$t('ContactUsText.p2_1')}`);
        if (!form.name)
          return alert(`请输入${this.$t('ContactUsText.p2_2')}`);
        if (!form.phone)
          return alert(`请输入${this.$t('ContactUsText.p2_3')}`);
        if (!form.email)
          return alert(`请输入${this.$t('ContactUsText.p2_4')}`);

        //Name,Phone,  Email,  Subject,  LeavingMessage
        let resp = await ConsultionInfo(form.name, form.phone, form.email, 'default', form.leavingMessage);
        if (resp.Status) {
          alert("提交成功");
          this.initForm();
          return;
        }
        return alert(resp.Msg ||  "提交失败");
      },
      initForm(){
        this.contactForm = {
          name: '',
          phone: '',
          email: '',
          leavingMessage: ''
        }
      },
    },
  }
</script>

<style scoped lang="scss">
  .v-contact-us-left {
    text-align: left;
    width: 45.5vw;

    .header {
      padding: 1.5vw 0;

      h2 {
        font-size: 2.5vw;
        font-weight: bold;
      }
    }

    .form-wrapper {
      .form-item {
        margin-bottom: 2.4vw;
        display: flex;
        justify-content: space-between;
        &:last-child{
          margin-bottom: 0;
        }

        
      }

      .form-name-phone {
        .input-name {
          width: 22vw;
        }

        .input-phone {
          width: 22vw;
        }
      }

      .form-content {
        .input-content {
          height: 15vw;
        }
      }

      .form-btn{
        
        .btn{
          padding: 10px 40px ;
          font-size: 1.25vw;
          // line-height: 2.66vw;
          color: #ed895a;
          border-color: #ec8c5e;
          background: white;
          outline: none;
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/contact/contact-us-left.vue